import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { NotificationManager } from "react-notifications";

export default function DownloadAnchor({
  func,
  cssClass,
  icon,
  hoverText,
  text,
}) {
  const [loading, setLoading] = useState(false);

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      onClick={async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
          await func();
        } catch (error) {
          // getBlob throws the Response on a non-OK status. Without this the
          // rejection is swallowed and setLoading(false) never runs, so a failed
          // download leaves the icon spinning forever with nothing shown to the user.
          console.error("Download failed:", error);
          NotificationManager.error(
            "The file could not be downloaded. Please try again or contact support.",
            "Download Failed"
          );
        } finally {
          setLoading(false);
        }
      }}
      title={hoverText}
      style={{ marginRight: "8px", marginLeft: "8px", color: "grey" }}
    >
      {loading ? (
        <FontAwesomeIcon className={`fa-spin ${cssClass}`} icon={faSpinner} />
      ) : (
        <FontAwesomeIcon
          icon={icon}
          style={{ height: "24px", width: "28px" }}
          className={`${cssClass}`}
        />
      )}{" "}
      {text}
    </a>
  );
}
